var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 25C20.0751 25 25 20.0751 25 14C25 7.92487 20.0751 3 14 3C7.92487 3 3 7.92487 3 14C3 20.0751 7.92487 25 14 25Z",
    fill: "#504D56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3447 17.4903L18.863 14.4369H15.621V12.4563C15.621 11.6208 16.0731 10.8058 17.5252 10.8058H19V8.20631C19 8.20631 17.6621 8 16.3836 8C13.7123 8 11.9681 9.46273 11.9681 12.1097V14.4369H9V17.4903H11.9681V24.8721C12.5639 24.9567 13.1735 25 13.7945 25C14.4155 25 15.0252 24.9567 15.621 24.8721V17.4903H18.3447Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.d9f755de9a9073fa340cd753a206e2eb.svg";
export { ForwardRef as ReactComponent };